/**
 * خريطة classes لكلّ تركيبة (placement × size).
 * النتائج تُطبَّق على عنصر الإطار الخارجيّ في BannerSlot / AmbassadorHeroSection.
 */
import type { BannerPlacement } from "@/utils/banner.types";

export type BannerSize = "compact" | "default" | "tall";

/**
 * يُرجع padding عموديّ (py-*) ومسافات هامش (my-*) مناسبة لكلّ مكان وحجم.
 * top_strip و anonymous_toast لا تتأثّران كثيراً (ارتفاع نصّي ثابت).
 */
export function getBannerSizeClasses(
  placement: BannerPlacement,
  size: BannerSize | null | undefined,
): { pad: string; margin: string } {
  const s: BannerSize = size ?? "default";

  switch (placement) {
    case "top_strip":
      // شريط نصّيّ — تأثير الحجم على padding فقط
      return {
        pad: s === "compact" ? "py-1" : s === "tall" ? "py-3" : "py-2",
        margin: "",
      };

    case "home_below_hero":
    case "shop_promo":
    case "product_promo":
      return {
        pad:
          s === "compact"
            ? "py-6 md:py-8"
            : s === "tall"
              ? "py-16 md:py-24"
              : "py-10 md:py-14",
        margin:
          s === "compact" ? "my-3 md:my-4" : s === "tall" ? "my-8 md:my-14" : "my-6 md:my-10",
      };

    case "home_between_blocks":
      return {
        pad:
          s === "compact"
            ? "py-6 md:py-8"
            : s === "tall"
              ? "py-14 md:py-20"
              : "py-8 md:py-12",
        margin:
          s === "compact" ? "my-2 md:my-3" : s === "tall" ? "my-6 md:my-10" : "my-4 md:my-6",
      };

    case "account_invite":
      return {
        pad:
          s === "compact" ? "py-4" : s === "tall" ? "py-12 md:py-16" : "py-8 md:py-10",
        margin: s === "compact" ? "my-2" : s === "tall" ? "my-6 md:my-8" : "my-4 md:my-6",
      };

    case "account_ambassador_slide":
      return {
        pad:
          s === "compact"
            ? "py-8 md:py-12"
            : s === "tall"
              ? "py-16 md:py-32"
              : "py-12 md:py-24",
        margin: "",
      };

    case "anonymous_toast":
      // Toast — الحجم لا يؤثّر بصرياً
      return { pad: "", margin: "" };

    default:
      return { pad: "", margin: "" };
  }
}
